import endpointDuckFactory from "./_endpointDuckFactory";

const deliveryIssuesDuck = endpointDuckFactory({ endpoint: "delivery-issues" });

export default deliveryIssuesDuck;
